import React, { Component, ReactNode } from 'react'
import { Box, Divider, Drawer, DrawerProps, IconButton, styled, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const drawerGlobalClasses = {
  root: 'DrawerGlobal-root',
  title: 'DrawerGlobal-title',
  content: 'DrawerGlobal-content',
  fullHeight: 'DrawerGlobal-fullHeight'
}

interface IProps {}

interface IState {
  title?: ReactNode
  icon?: ReactNode
  fullHeight?: boolean
  anchor?: DrawerProps['anchor']
  /** @default true */
  backdropClickeable?: boolean
  renderContent?: () => ReactNode
}

type TReason = 'backdropClick' | 'escapeKeyDown'

interface DrawerGlobalApiType {
  open: (state: IState) => void
  close: (reason?: TReason) => void
}

const DrawerGlobalApi: DrawerGlobalApiType = {
  close: () => {
    console.warn('DrawerGlobal provider not found!')
  },
  open: () => {
    console.warn('DrawerGlobal provider not found!')
  }
}

class DrawerGlobalProvider extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props)
    this.state = {}
  }

  close = (reason?: TReason) => {
    if (this.state.backdropClickeable === false && reason === 'backdropClick') return
    this.setState({ renderContent: undefined })
  }

  open = (state: IState) => this.setState(state)

  componentDidMount() {
    DrawerGlobalApi.open = this.open
    DrawerGlobalApi.close = this.close
  }

  render() {
    return (
      <Drawer anchor={this.state.anchor} open={Boolean(this.state.renderContent)} onClose={(_, reason) => this.close(reason)}>
        <Wrap className={this.getClasses()}>
          <div className={drawerGlobalClasses.title}>
            {this.state.icon}
            {this.renderTitle()}
            <Box sx={{ flex: 1 }} />
            <IconButton onClick={() => this.close()}>
              <CloseIcon />
            </IconButton>
          </div>
          <Divider variant='middle' />
          <div className={drawerGlobalClasses.content}>{this.state.renderContent && this.state.renderContent()}</div>
        </Wrap>
      </Drawer>
    )
  }

  renderTitle = () => {
    if (typeof this.state.title === 'string') {
      return (
        <Typography variant='h6' noWrap>
          {this.state.title}
        </Typography>
      )
    }
    return this.state.title
  }

  getClasses = () => {
    const classes = [drawerGlobalClasses.root]
    if (this.state.fullHeight) classes.push(drawerGlobalClasses.fullHeight)
    return classes.join(' ')
  }
}

const DrawerGlobal = {
  Provider: DrawerGlobalProvider,
  Api: DrawerGlobalApi
}

export default DrawerGlobal

const Wrap = styled(Box)({
  '--height-title': '56px',
  [`.${drawerGlobalClasses.title}`]: {
    display: 'flex',
    alignItems: 'center',
    height: 'var(--height-title)',
    padding: '0 12px',
    gap: '6px'
  },
  [`&.${drawerGlobalClasses.fullHeight}`]: {
    [`.${drawerGlobalClasses.content}`]: {
      height: 'calc(100vh - var(--height-title) - 60px)'
    }
  }
})
